class AlertCardController {
  constructor() {}

  $onInit() {
    this.messageAlert = true;
  }

  getClasses() {
    return { 
      'responsiveMobile': this.isMobileApp , 
      'bluish-style': this.alertStyle == 'bluish', 
      'red-style': this.alertStyle == 'red'
    };
  }

}

export default AlertCardController;


// WEBPACK FOOTER //
// ./client/app/components/alertCard/alertCard.controller.js